import type { FC, MouseEventHandler } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useShallowPickSelector } from "store/useSelector";
import { BottomSheet } from "components/atoms/BottomSheet";
import { appActions } from "store/app/app.slice";
import { ReactComponent as LogoutSVG } from "assets/images/logout-outline.svg";
import { logout } from "store/current-user/current-user.thunk";

export const LogoutConfirmationMenu: FC = () => {
  const { logoutConfirmationMenu } = useShallowPickSelector("app", [
    "logoutConfirmationMenu",
  ]);
  const { user } = useShallowPickSelector("currentUser", ["user"]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const _location = useLocation();

  const onClose = () => {
    dispatch(
      appActions.setLogoutConfirmationMenu({
        isOpen: false,
      })
    );
  };

  const onClickLogout: MouseEventHandler = () => {
    dispatch(logout());
  };

  return (
    <BottomSheet isOpen={logoutConfirmationMenu.isOpen} onClose={onClose}>
      <Stack alignItems={"center"} mt={3}>
        <Box
          borderRadius={"50%"}
          px={5.2}
          pb={4.5}
          pt={5}
          bgcolor={"rgba(255,255,255,0.05)"}
        >
          <LogoutSVG height={"40px"} width={"40px"} />
        </Box>
        <Typography fontSize={"1.125rem"} fontWeight={700} mt={4}>
          خروج از حساب کاربری
        </Typography>
        <Typography
          fontSize={"0.875rem"}
          fontWeight={400}
          color={"rgba(255,255,255,0.5)"}
          sx={{ direction: "rtl" }}
          mb={4}
          mx={5}
          textAlign={"center"}
        >
          آیا مایلید از حساب کاربری خود خارج شوید؟
        </Typography>
        <Stack mx={5} alignSelf={"stretch"} spacing={1}>
          <Button variant={"contained"} fullWidth onClick={onClickLogout}>
            خروج
          </Button>
          <Button color={"secondary"} fullWidth onClick={onClose}>
            انصراف
          </Button>
        </Stack>
      </Stack>
    </BottomSheet>
  );
};
